import { render, staticRenderFns } from "./LoginSection.vue?vue&type=template&id=07fa9c5c&scoped=true"
import script from "./LoginSection.vue?vue&type=script&lang=js"
export * from "./LoginSection.vue?vue&type=script&lang=js"
import style0 from "./LoginSection.vue?vue&type=style&index=0&id=07fa9c5c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07fa9c5c",
  null
  
)

export default component.exports